export const EVENT_NAME = {
  1: 'alarmReceived',
  2: 'alarmSelected',
  3: 'alarmNotProcessed',
  4: 'alarmProcessed',
  5: "alarmStartIntervention",
  6: "alarmEndIntervention",
};
